module.exports = __webpack_public_path__ + "static/media/chevronLeft.8cb9c02f.svg";